import {
  GroupTelemetryKeys,
  GroupTelemetryValues,
} from './groupTelemetryConstants';

export interface ITelemetryEvent {
  name: string;
  properties?: Map<GroupTelemetryKeys, GroupTelemetryValues>;
  errorEvent?: {
    eventName: string;
    eventProperties?: Map<GroupTelemetryKeys, GroupTelemetryValues>;
  };
}

export type EventFlow = Record<string, ITelemetryEvent>;

export const groupTelemetryEvents: Record<string, EventFlow> = {
  addGroup: {
    start: {
      name: 'Add Group: Started',
    },
    addGroupDetails: {
      name: 'Add Group: Added Group Details',
    },
    addUserCreateGroup: {
      name: 'Add Group: Added Users And Created Group',
      errorEvent: {
        eventName: 'Add Group: Failed',
      },
    },
  },
  mapIdentityProviderGroupFlow: {
    start: {
      name: 'Map IdP Groups: Started',
      errorEvent: {
        eventName: 'Map IdP Groups: Error Getting IdP',
      },
    },
    confirmIdp: {
      name: 'Map IdP Groups: Confirmed IdP',
    },
    updateIdpGroupMapping: {
      name: 'Map IdP Groups: Updated IdP Group Mapping',
      properties: new Map([[GroupTelemetryKeys.NoOfGroupMapping, 1]]),
    },
    reviewSaveIdpGroupMapping: {
      name: 'Map IdP Groups: Reviewed And Saved IdP Group Mapping',
      errorEvent: {
        eventName: 'Map IdP Groups: Save Failed',
      },
    },
  },
  editDeleteGroupOperations: {
    deleteGroup: {
      name: 'Groups: Deleted Group',
      errorEvent: {
        eventName: 'Groups: Delete Failed',
      },
    },
    editGroupName: {
      name: 'Edit Groups: Edited Group Name',
      errorEvent: {
        eventName: 'Edit Groups: Name Update Failed',
      },
    },
    removeRoleFromGroup: {
      name: 'Edit Groups: Role Removed For The Group',
      errorEvent: {
        eventName: 'Edit Groups: Failed To Remove Role From Group',
      },
    },
    assignRoleForGroup: {
      name: 'Edit Groups: Role Assigned For The Group',
      properties: new Map([[GroupTelemetryKeys.NoOfRolesAssigned, 1]]),
      errorEvent: {
        eventName: 'Edit Groups: Failed To Assign Role To Group',
      },
    },
    removeUserFromGroup: {
      name: 'Edit Groups: User Removed From The Group',
      errorEvent: {
        eventName: 'Edit Groups: Failed To Remove User From Group',
      },
    },
    removeUsersFromGroup: {
      name: 'Edit Groups: Users Removed From The Group',
      errorEvent: {
        eventName: 'Edit Groups: Failed To Remove Users From Group',
      },
    },
    addUserToGroup: {
      name: 'Edit Groups: User Added To The Group',
      properties: new Map([[GroupTelemetryKeys.NoOfUsersAdded, 1]]),
      errorEvent: {
        eventName: 'Edit Groups: Failed To Assign User To Group',
      },
    },
    groupsDetailsViewed: {
      name: 'Groups: Details Viewed',
      properties: new Map([[GroupTelemetryKeys.GroupType, 'Local']]),
    },
  },
};
